import React from 'react';
import { FiXCircle, FiArrowLeftCircle } from "react-icons/fi"
export default function Alert (props) {
    const {title,comment,options,setAlert} = props
    return(
        <div
        intensity={25}
        tint='dark'
        style={{
            position:'absolute',
            width:'100%',
            height:'100%',
            zIndex:999, 
        }}>
            <div 
            onClick={()=>{setAlert(null)}}
            style={{
                display: 'flex',
                width:'100%',
                height:'100%',
                justifyContent:'center'
            }}>
                <div style={{
                    backgroundColor:'black',
                    borderWidth:2,
                    borderColor:"var(--red)",
                    borderRadius:10,
                    minWidth:300,
                    alignSelf:'center',
                    justifySelf:'center',
                    padding:10
                }}>
                    {title && <p style={{color:'white',textAlign:'center'}}>{title}</p>}
                    <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                    {comment && <p style={{color:"var(--wht)",textAlign:'center',paddingBottom:5}}>{comment}</p>}
                    {options && <div style={{flexDirection:'row',justifyContent:'space-evenly', display: "flex"}}>
                        {options.map(i =>
                            <button
                                key={i.text}
                                style={{color: i.style == 'destructive' ? "var(--red)" : i.style == 'cancel' ? 'white':"var(--wht)", }}
                                onClick={i.style == 'cancel' ? ()=>{setAlert(null)} : ()=>{i.onClick();setAlert(null)}}
                                >
                                {i.text}
                                {i.style == 'destructive' ? <FiXCircle /> : i.style == 'cancel' && <FiArrowLeftCircle />}
                                
                            </button>)}
                    </div>}
                </div>
            </div>
        </div>
    )
}